import _ from 'lodash'
import moment from 'moment'

function getTripSlug() {
  const path = _.get(window, 'location.pathname');
  return _.get(path.split('/trips/'), '[1]');
}

export function getRAQFormUrl(isReverse, startDate) {
  const slug = getTripSlug();
  let url = `${_.get(window, 'location.origin')}/vacation-quote-request?name=${slug}`
  if (isReverse) {
    url = `${url}&revreq=1`
  }
  if (startDate && moment(startDate).isValid()) {
    url = `${url}&leaving_on=${moment(startDate).format('YYYY-MM-DD')}`
  }
  return url
}
